import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_TYPE} from '../../../utils/DropdownOptionPropsUtils';

export const presentationFileTypeResource: DropdownOptionProps[] = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'odp', value: 'odp'
    },
    {
        name: 'vnd.oasis.opendocument.presentation', value: 'vnd.oasis.opendocument.presentation'
    },
    {
        name: 'pptx', value: 'pptx'
    },
    {
        name: 'vnd.openxmlformats-officedocument.presentationml.presentation',
        value: 'vnd.openxmlformats-officedocument.presentationml.presentation'
    },
    {
        name: 'ppt', value: 'ppt'
    },
    {
        name: 'vnd.ms-powerpoint', value: 'vnd.ms-powerpoint'
    }
];